import { Routes, Route } from "react-router-dom";
import { ROUTES } from "./routePaths";
import { lazy, Suspense, useState, useEffect } from "react";
import ProtectedRoute from "./ProtectedRoutes";
import PublicRoutes from "./PublicRoutes";
import Loader from "../components/Loader/Loader";
import DownloadApp from "../containers/DownloadApp/DownloadApp";
import ScrollToTop from "../components/ScrollToTop/ScrollToTop";
import {
  checkNetworkStatus,
  subscribeToNetwork,
} from "../utils/networkManager";
import NoInternet from "../components/NoInternet/NoInternet";
const HomeScreen = lazy(() => import("../containers/HomeScreen/HomeScreen"));
const AppInitializer = lazy(
  () => import("../containers/AppInitializer/AppInitializer"),
);
const Login = lazy(() => import("../containers/Auth/Login"));
const LoginOTP = lazy(() => import("../containers/Auth/LoginOTP"));
const EmailVerification = lazy(() => import("../containers/EmailVerification"));
const PersonalDetailsForm = lazy(() => import("../containers/PersonalDetails"));
const EligibilityCheckPending = lazy(
  () => import("../containers/EligibilityCheck/EligibilityCheckPending"),
);

const EligibilityCheckFailed = lazy(
  () => import("../containers/EligibilityCheck/EligibilityCheckFailed"),
);
const EligibilityCheckManual = lazy(
  () => import("../containers/EligibilityCheck/EligibilityCheckManual"),
);
const IncomeDetailsForm = lazy(() => import("../containers/IncomeDetails"));
const AddressDetailsForm = lazy(() => import("../containers/AddressDetails"));
const PanCheckPending = lazy(
  () => import("../containers/PanCheck/PanCheckPending/PanCheckPending"),
);
const PanCheckFailed = lazy(
  () => import("../containers/PanCheck/PanCheckFailed/PanCheckFailed"),
);
const OnHold = lazy(() => import("../containers/PanCheck/OnHold"));

export default function AppRoutes() {
  const [isOnline, setIsOnline] = useState(checkNetworkStatus());

  useEffect(() => {
    const currentStatus = checkNetworkStatus();
    setIsOnline(currentStatus);

    const timer = setTimeout(() => {
      setIsOnline(navigator.onLine);
    }, 5000);

    const unsubscribe = subscribeToNetwork((status) => {
      setIsOnline(status);
    });

    return () => {
      unsubscribe();
      clearTimeout(timer);
    };
  }, []);

  return (
    <>
      {!isOnline && <NoInternet />}
      <Suspense fallback={<Loader text="Fetching your details..." />}>
        <ScrollToTop />
        <Routes>
          {/* Public Routes */}
          <Route path={ROUTES.ROOT} element={<HomeScreen />} />
          <Route path={ROUTES.HOME} element={<HomeScreen />} />
          <Route
            path={ROUTES.LOGIN}
            element={
              <PublicRoutes>
                <HomeScreen />
              </PublicRoutes>
            }
          />
          <Route
            path={ROUTES.LOGIN_OTP}
            element={
              <PublicRoutes>
                <HomeScreen />
              </PublicRoutes>
            }
          />
          {/* Protected Routes */}
          <Route
            path={ROUTES.APP_INITIALIZER}
            element={
              <ProtectedRoute>
                <AppInitializer />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.EMAIL_VERIFICATION}
            element={
              <ProtectedRoute>
                <EmailVerification />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.PERSONAL_DETAILS}
            element={
              <ProtectedRoute>
                <PersonalDetailsForm />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.PAN_CHECK_PENDING}
            element={
              <ProtectedRoute>
                <PanCheckPending />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.PAN_CHECK_FAILED}
            element={
              <ProtectedRoute>
                <PanCheckFailed />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.ON_HOLD}
            element={
              <ProtectedRoute>
                <OnHold />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.INCOME_INFO}
            element={
              <ProtectedRoute>
                <IncomeDetailsForm />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.ADDRESS_DETAILS}
            element={
              <ProtectedRoute>
                <AddressDetailsForm />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.ELIGIBILITY_CHECK_PENDING}
            element={
              <ProtectedRoute>
                <EligibilityCheckPending />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.ELIGIBILITY_CHECK_FAILED}
            element={
              <ProtectedRoute>
                <EligibilityCheckFailed />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.ELIGIBILITY_CHECK_MANUAL}
            element={
              <ProtectedRoute>
                <EligibilityCheckManual />
              </ProtectedRoute>
            }
          />
          <Route path={ROUTES.DOWNLOAD_APP} element={<DownloadApp />} />
        </Routes>
      </Suspense>
    </>
  );
}
